import { render, staticRenderFns } from "./LabelModal6a3.vue?vue&type=template&id=2235cfdb&scoped=true&"
import script from "./LabelModal6a3.vue?vue&type=script&lang=js&"
export * from "./LabelModal6a3.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal6a3.vue?vue&type=style&index=0&id=2235cfdb&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal6a3.vue?vue&type=style&index=1&id=2235cfdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2235cfdb",
  null
  
)

export default component.exports